@if(login){
  <mat-tab-group
  (selectedTabChange)="onTabChange($event)"
  [(selectedIndex)]="selectedIndex"
>
  <mat-tab label="Devices">
    <app-devices [tabSelected]="selectedIndex === 0"></app-devices>
  </mat-tab>
  <mat-tab label="Groups">
    <app-groups [tabSelected]="selectedIndex === 1"></app-groups>
  </mat-tab>
  <mat-tab label="Firmwares">
    <app-firmwares [tabSelected]="selectedIndex === 2"></app-firmwares>
  </mat-tab>
  <mat-tab label="Deploys">
    <app-deploys [tabSelected]="selectedIndex === 3"></app-deploys>
  </mat-tab>
</mat-tab-group>
}
  

